import { render, staticRenderFns } from "./CloseJobReasonList.vue?vue&type=template&id=6d88ea19&"
import script from "./CloseJobReasonList.vue?vue&type=script&lang=js&"
export * from "./CloseJobReasonList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports